import dayjs from "dayjs";
import { stripPostInlineStyles } from "../../utils";

export const POSTS_PER_PAGE = 7;

export const getPostTypeLabel = (post) =>
  post?.contentTypeId === 2 ? "Video" : "Blog";

export const getPlainExcerpt = (html) => {
  const sanitized = stripPostInlineStyles(html || "");
  if (typeof DOMParser === "undefined") {
    return sanitized.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  }
  const doc = new DOMParser().parseFromString(sanitized, "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
};

export const formatPostDate = (publishedAt) => {
  if (!publishedAt) return "";
  return dayjs(publishedAt).format("MMM D, YYYY");
};

export const buildMemberFilter = ({
  authorIds,
  startDate,
  endDate,
}) => ({
  authorIds: authorIds || [],
  tagIds: [],
  educationOnly: false,
  contentAvailabilityId: 2,
  publishedAt: {
    from: startDate ? `${startDate} 00:00:00` : null,
    to: endDate ? `${endDate} 23:59:59` : null,
  },
});

const range = (start, end) =>
  Array.from({ length: end - start + 1 }, (_, index) => start + index);

/** Compact page list with ellipsis — Lovable look, production-safe for many pages. */
export const buildPaginationItems = (
  currentPage,
  totalPages,
  siblingCount = 1
) => {
  if (totalPages <= 1) return [];

  const toPageItems = (pages) =>
    pages.map((page) => ({ type: "page", value: page }));

  if (totalPages <= 7) {
    return toPageItems(range(1, totalPages));
  }

  const leftSibling = Math.max(currentPage - siblingCount, 1);
  const rightSibling = Math.min(currentPage + siblingCount, totalPages);
  const showLeftEllipsis = leftSibling > 2;
  const showRightEllipsis = rightSibling < totalPages - 1;

  if (!showLeftEllipsis && showRightEllipsis) {
    return [
      ...toPageItems(range(1, 3 + siblingCount * 2)),
      { type: "ellipsis", key: "right" },
      { type: "page", value: totalPages },
    ];
  }

  if (showLeftEllipsis && !showRightEllipsis) {
    return [
      { type: "page", value: 1 },
      { type: "ellipsis", key: "left" },
      ...toPageItems(range(totalPages - (3 + siblingCount * 2) + 1, totalPages)),
    ];
  }

  if (showLeftEllipsis && showRightEllipsis) {
    return [
      { type: "page", value: 1 },
      { type: "ellipsis", key: "left" },
      ...toPageItems(range(leftSibling, rightSibling)),
      { type: "ellipsis", key: "right" },
      { type: "page", value: totalPages },
    ];
  }

  return toPageItems(range(1, totalPages));
};
